import { createMuiTheme } from "@material-ui/core/styles";

export const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
    primary: {
      main: "#00FFE0",
    },
    secondary: {
      main: "#FFF",
    },
  },
});

export const lightTheme = createMuiTheme({
  palette: {
    type: "light",
    primary: {
      main: "#000",
    },
    secondary: {
      main: "#FFF",
    },
    text: {
      secondary: "#000",
    },
  },
  typography: {
    fontFamily: "Raleway",
    // Main page title
    h1: {
      fontFamily: "Playfair Display",
      fontSize: "2.3rem",
    },
    // Titles
    h2: {
      fontFamily: "Playfair Display",
      fontSize: "1.7rem",
    },
    h4: {
      fontFamily: "Playfair Display",
      fontSize: 22,
      padding: 0,
      paddingBottom: "0.5em",
    },
    h5: {
      fontFamily: "Raleway",
      fontSize: "1.1rem",
      letterSpacing: "0.1rem",
    },
    subtitle1: {
      fontFamily: "Raleway",
    },
    subtitle2: {
      fontFamily: "Playfair Display",
      fontSize: "1.3rem",
      fontWeight: "bold",
      // letterSpacing: "0.1rem",
    },
    body1: {
      fontFamily: "Raleway",
      fontSize: "1.1rem",
    },
    body2: {
      fontFamily: "Raleway",
      fontSize: "0.8rem",
    },
  },
});
